const getProtocol = (request) => {
  const {
    headers: { 'x-forwarded-proto': protocol = request.protocol } = {},
  } = request;

  return protocol;
};

export default getProtocol;
